import { useMemo, useState } from "react";
import ArticleCard from "@/components/feature/ArticleCard";
import HotSidebar from "@/components/feature/HotSidebar";
import { articles, categories } from "@/mocks/news";

const PAGE_SIZE = 4;

export default function LatestSection() {
  const [active, setActive] = useState("all");
  const [visible, setVisible] = useState(PAGE_SIZE);

  const filtered = useMemo(() => {
    const list =
      active === "all" ? articles : articles.filter((item) => item.categorySlug === active);
    return [...list].sort(
      (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
    );
  }, [active]);

  const shown = filtered.slice(0, visible);

  return (
    <section id="today-feed" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-site px-4 py-14 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-[0.2em] text-primary-600">LIVE FEED</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              今日速递
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按时间倒序滚动上新，热点时段持续刷新。
            </p>
          </div>
          <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            正在更新
          </span>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div
              role="tablist"
              aria-label="速递分类筛选"
              className="guwa-scrollbar flex gap-2 overflow-x-auto pb-1"
            >
              <button
                type="button"
                role="tab"
                aria-selected={active === "all"}
                onClick={() => {
                  setActive("all");
                  setVisible(PAGE_SIZE);
                }}
                className={`whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors ${
                  active === "all"
                    ? "bg-foreground-950 font-medium text-background-50"
                    : "bg-background-50 text-foreground-700 hover:bg-background-200"
                }`}
              >
                全部速递
              </button>
              {categories.map((item) => (
                <button
                  key={item.slug}
                  type="button"
                  role="tab"
                  aria-selected={active === item.slug}
                  onClick={() => {
                    setActive(item.slug);
                    setVisible(PAGE_SIZE);
                  }}
                  className={`whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors ${
                    active === item.slug
                      ? "bg-foreground-950 font-medium text-background-50"
                      : "bg-background-50 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {item.name}
                </button>
              ))}
            </div>

            <div className="mt-6 space-y-4">
              {shown.length === 0 && (
                <p className="rounded-lg border border-background-200 bg-background-50 p-6 text-center text-sm text-foreground-600">
                  该栏目暂时没有新的瓜料，去其他栏目看看吧。
                </p>
              )}
              {shown.map((item) => (
                <ArticleCard key={item.id} article={item} variant="wide" />
              ))}
            </div>

            {visible < filtered.length && (
              <div className="mt-8 text-center">
                <button
                  type="button"
                  onClick={() => setVisible((prev) => prev + PAGE_SIZE)}
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
                >
                  <i className="ri-refresh-line" aria-hidden="true"></i>
                  加载更多速递（剩余 {filtered.length - visible} 条）
                </button>
              </div>
            )}
          </div>

          <div className="lg:col-span-4">
            <HotSidebar />
          </div>
        </div>
      </div>
    </section>
  );
}